import { getUtmLabelParams, IStartParams, IUtmLabels } from "../../../chat/~store/models/StartParams";
import { getURLParameters } from "../url-helper/UrlHelper";

export const TryGetStartParamsFromQueryString = (): IStartParams | undefined => {
    const parent = getParent();
    
    const utmLabels = tryGetUtmParamsfromQueryString();
    const searchParams = getURLParameters(parent);
    const startBot = searchParams["startbot"];
    const additionaldata = searchParams["additionaldata"];
    return {
        startBot,
        additionaldata,
        utmLabels
    }
}

export const tryGetUtmParamsfromQueryString = (): IUtmLabels | undefined => {
    let utmLabels = undefined;
    const parent = getParent();
    const searchParams = getURLParameters(parent);
    const allUtmParams = getUtmLabelParams();

    for(const p of allUtmParams) {
        if(searchParams[p.toLowerCase()]) {
            if(utmLabels === undefined) utmLabels = {} as IUtmLabels
            utmLabels[p] = searchParams[p.toLowerCase()];
        }
    }
    
    return utmLabels;
}

const getParent = (): string => {
    return window.location.search.split("&parent=")[1]?.toLowerCase();
}